import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { MatButtonModule, MatSelectModule, MatPaginatorModule, MatIconModule, MatBadgeModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { MdModule } from 'src/app/md/md.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalsModule } from '../../modals/modals.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MaterialModule } from 'src/app/material.module';
import { ICNavbarComponent } from 'src/app/icnavbar/icnavbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ICNavBarFeedItemLayoutComponent } from 'src/app/icnavbar/icnav-bar-feed-item-layout/icnav-bar-feed-item-layout.component';
@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    MatButtonModule,
    FormsModule,
    MdModule,
    MatSelectModule,
    MaterialModule,
    MatPaginatorModule,
    NgSelectModule,
    ModalsModule,
    PerfectScrollbarModule,
    MatIconModule,
    MatBadgeModule,
    BrowserAnimationsModule,
  ],
  declarations: [NavbarComponent, ICNavbarComponent, ICNavBarFeedItemLayoutComponent],
  exports: [NavbarComponent],
  entryComponents: [],
})
export class NavbarModule {}
